import mockWorkData from "./mockWorkExperienceData.json"; // Import your JSON file

export const WorkService = {
  async fetchWorkData() {
    const convertedWorkData = mockWorkData.workExperiences.map((experience) => {
      return {
        company: experience.company,
        role: experience.role,
        dateStarted: new Date(experience.dateStarted),
        dateEnded:
          experience.dateEnded !== ""
            ? new Date(experience.dateEnded)
            : undefined,
      };
    });
    return convertedWorkData;
  },
};
